import { Event } from './event';

export class EnrolmentReviewDoneEvent extends Event<void> {}
